import { Fragment, useEffect, useState } from "react";
import { useAxios } from "utils/CustomHooks";
import { Modal } from "react-bootstrap";
import { ReactComponent as ConfirmIcon } from "assets/images/big-tik.svg";
import { Button, Toast } from "components";
import { useHistory } from "react-router-dom";
import EditableRow from "./EditableRow/EditableRow";
import "./kitchenEditableList.scss";

const KitchenEditableList = ({
    titleList,
    foods,
    dataObject,
    isView,
    filename,
    submitDisabled,
    timeSavedReceiving,
    date,
}) => {
    const [submitGoodOrders, setSubmitGoodOrders] = useAxios();
    const [variancedData, setVariancedData] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [toastState, setToastState] = useState({
        isShow: false,
        message: "",
    });
    let history = useHistory();

    useEffect(() => {
        if (submitGoodOrders?.response?.status === "OK") {
            setShowModal(true);
        }
    }, [submitGoodOrders]);

    const logChangeOrders = (id, receiving_count) => {
        const currentIndex = foods?.findIndex(
            (food) => Number(food?.good_id) === Number(id)
        );
        const currentItems = [...foods];
        currentItems[currentIndex].has_variance = true;
        currentItems[currentIndex].receiving_count = receiving_count;
        setVariancedData(currentItems);
    };

    const handleSubmit = () => {
        setTimeout(() => {
            setToastState({
                isShow: false,
                message: "",
            });
        }, 3000);

        if (!timeSavedReceiving) {
            return setToastState({
                isShow: true,
                message: "لطفا زمان ورود را وارد کنید",
            });
        }
        let requestMethod;
        const newData = Object.assign({}, dataObject);
        if (variancedData !== null) {
            newData["receiving_items"] = variancedData;
        }
        if (filename) {
            newData["file_name"] = filename;
        }
        if (newData.receiving_items[0]?.id === 0) {
            requestMethod = "post";
        } else {
            requestMethod = "put";
        }
        setSubmitGoodOrders({
            method: requestMethod,
            url: `/admin/dry/receiving/${date}`,
            data: newData,
        });
    };

    const handleRedirectToList = () => {
        setShowModal(false);
        setTimeout(() => {
            history.push("/dry-receiving");
        }, 500);
    };

    const handleShowModal = (show) => {
        setShowModal(show);
    };

    return (
        <Fragment>
            <div className="table-wrapper">
                <table className="table new-kitchen-editable-list rtl">
                    <thead className="thead">
                        <tr className="tr">
                            <th className="th">بار خشک</th>
                            {titleList.map((item) => {
                                return (
                                    <th className="th" key={item.id}>
                                        {item.title}
                                    </th>
                                );
                            })}
                        </tr>
                    </thead>
                    <tbody className="tbody">
                        {foods ? (
                            <Fragment>
                                {foods?.map((food) => {
                                    return (
                                        <EditableRow
                                            key={food?.good_id}
                                            food={food}
                                            handleLogChange={logChangeOrders}
                                        />
                                    );
                                })}
                            </Fragment>
                        ) : (
                            <tr className="tr">
                                <td className="td">آیتمی موجود نیست.</td>
                            </tr>
                        )}
                    </tbody>
                </table>
                {!isView && foods && (
                    <Button
                        btnText={"ثبت"}
                        className="solid is-green pushLeft receiving-submit-btn"
                        handleClick={() => {
                            if (!timeSavedReceiving) {
                                return setToastState({
                                    isShow: true,
                                    message: "لطفا زمان ورود را وارد کنید",
                                });
                            } else {
                                handleSubmit();
                            }
                        }}
                        loading={submitGoodOrders.loading}
                        disabled={submitDisabled || false}
                    />
                )}
            </div>

            <Modal
                show={showModal}
                onHide={() => handleShowModal(false)}
                className="rtl confirm-submit-order"
                aria-labelledby="contained-modal-title-vcenter"
                centered
                data-testid="ConfirmModal"
            >
                <Modal.Body>
                    <ConfirmIcon className="confirm-logo" />
                    "تغییرات انجام شد. جهت مشاهده نتیجه به صفحه لیست دریافتی ها
                    مراجعه کنید."
                </Modal.Body>
                <Button
                    btnText="تایید"
                    className="solid is-green"
                    handleClick={handleRedirectToList}
                />
            </Modal>
            <Toast
                className="danger"
                isShow={toastState.isShow}
                title={toastState.message}
            />
        </Fragment>
    );
};

export default KitchenEditableList;
